
import { Button, Col, Row, Dropdown, Form, Alert} from "react-bootstrap";
import { PencilSimple, X, Info, Eye, Trash, DotsThreeVertical, Plus, Waveform, Moon, MapPinSimple, Calculator, Warning, Circle } from "@phosphor-icons/react";
import DataTable from 'react-data-table-component';
import atlasApi from "../utils/atlasapi";
import {format_power, generateId} from "../utils/functions";
import EditNow from "../components/EditNow";
import DoNowButton from "../components/DoNowButton";
import ShowStatus from "../components/ShowStatus";
import ReactDOM from "react-dom/client";
import Tool from "../classes/Tool";
import LayerSensor from "../classes/LayerSensor";

class ToolSensor extends Tool {

	tabIndex			= null;
	highlightedOnList	= [];

	noiseStatus			= {state:false};
	shadowStatus		= {state:false};

	modified			= false;

	ADD					= 1;
	REMOVE				= 2;

	type				= 'sensors';
	itemsName			= 'nsas';
	id					= 'nsaid';
	infolayerId			= 'sensors';
	stateMsgs			= {
		new:			'Start calculating noise and shadow',
		again:			'Recalculate and update Noise and Shadow',
		pending:		'Calculating noise and shadow...',
		complete:		'Calculation complete',
		error:			'Calculation failed',
	}
	requestStatus	= {
		
	}
	calcAnim		= [
		{
			when: row => row.outdated,
			classNames: ["shimmer"]
		}
	];

	constructor(p, mode) {
		super();
		this.tc			= p;
		this.canvas		= this.tc.map.getCanvasContainer();
		this.getHiddenItems();
		this.setupStreamer('sensors');
		this.handleCalcRequestDone();
		this.handleDoneCalc();
	}
	getToolLayer() {
		return LayerSensor;
	}
	setCursor(cur){
		this.tc.map.getContainer().classList.add(cur);
		return this;
	}
	remCursor(cur){
		this.tc.map.getContainer().classList.remove(cur);
		return this;
	}
	setRemoveSensorListener(){
		this.setCursor("cursor-delete-sensor");
		this.tc.map.on('click', this.removeSensor);
	}
	setAddSensorListener(){
		this.setCursor("cursor-add-sensor");
		this.tc.map.on('click', this.addSensor);
	}
	update(){

	}
	init(){
		this.display();
		this.setEventHandlers();
	}
	exit(){
		if(this.tc.serviceBar.current)
			this.tc.serviceBar.current.clear(ToolSensor.tabIndex);
		ToolSensor.tabIndex = null;
		this.removeEventHandlers();
		atlasApi.abortRequests("sensors");
		this?.stream?.close();
	}
	setEventHandlers(){
		if(!this.tc)
			return;
		this.setAddSensorListener();
		this.tc.map.on('contextmenu', this.handleRightClick);
		this.setInOutListeners();
		this.tc.map.on('mousedown', LayerSensor.layerId, this.onDown);
		this.tc.map.on('touchstart', LayerSensor.layerId, this.onTouchStart);
	}
	setInOutListeners(){
		this.tc.map.on('mouseenter', LayerSensor.layerId, this.onEnter);
		this.tc.map.on('mouseleave', LayerSensor.layerId, this.onLeave);
	}
	unsetInOutListeners(){
		this.tc.map.off('mouseenter', LayerSensor.layerId, this.onEnter);
		this.tc.map.off('mouseleave', LayerSensor.layerId, this.onLeave);
	}
	removeEventHandlers(){
		if(!this.tc)
			return;
		this.tc.map.off('click', this.removeSensor);
		this.tc.map.off('click', this.addSensor);
		this.remCursor("cursor-add-sensor");
		this.remCursor("cursor-delete-sensor");
		this.tc.map.off('contextmenu', this.handleRightClick);
		this.unsetInOutListeners();
		this.tc.map.off('mousedown', LayerSensor.layerId, this.onDown);
		this.tc.map.off('touchstart', LayerSensor.layerId, this.onTouchStart);
	}

	onDown = (e) => {
		if(e.originalEvent.which != 1)
			return;
		e.preventDefault();
		this.unsetInOutListeners();
		this.getClickedSensor(e);
		this.setCursor('cursor-grabbing');
		this.tc.map.mouseDown = true;
		this.tc.map.on('mousemove', this.onMove);
		this.tc.map.once('mouseup', this.onUp);
	}
	onMove = (e) => {
		const coords = e.lngLat;
		this.hasMoved = true;
		this.canvas.style.cursor = 'grabbing';
		LayerSensor.data.features[this.currentSensorIdx].geometry.coordinates = [coords.lng, coords.lat];
		this.setData(LayerSensor.data);
	}
	onUp = (e) => {
		if(e.originalEvent.which != 1)
			return;
		const coords = e.lngLat;
		
		this.setInOutListeners();
		this.remCursor('cursor-grabbing');
		if(this.hasMoved && this.currentSensorId){
			this.updateSensor(this.currentSensorId, [coords.lng, coords.lat]);
			this.hasMoved = false;
		}
		this.currentSensorId = false;
		this.currentSensorIdx = false;
		delete this.tc.map.mouseDown;
		this.tc.map.off('mousemove', this.onMove);
		this.tc.map.off('touchmove', this.onMove);
		//this.resetLayer();
	}
	onTouchStart = (e) => {
		if(e.points.length !== 1)
			return;
		e.preventDefault();
		this.getClickedSensor(e);
		this.tc.map.mouseDown = true;
		this.tc.map.on('touchmove', this.onMove);
		this.tc.map.once('touchend', this.onUp);
	}
	getClickedSensor(e){
		var features = this.tc.map.queryRenderedFeatures(e.point, {layers:[LayerSensor.layerId]});
		if(features[0]){
			this.currentSensorId	= features[0].id ?? features[0].properties.tempid;
			this.currentSensorIdx	= features[0].properties.idx;
		}
	}
	onEnter = (e) => {
		this.remCursor("cursor-add-sensor").setCursor("cursor-pointer");
		const id = e.features[0].id ?? e.features[0].properties.tempid;
		this.highlightOnMap(id);
		this.highlightOnList(id);
	}
	onLeave = (e) => {
		this.remCursor("cursor-pointer").setCursor("cursor-add-sensor");
		this.deHighlightOnMap();
		this.deHighlightOnList(this.lastHoverId);
	}
	addSensor = (e)=>{

		this.closeContextMenu();

		if(this.tc.secondaryHandler)
			return;

		var features = this.tc.map.queryRenderedFeatures(e.point, {layers:[LayerSensor.layerId]});
		if(features.length){
			this.handleSensorClick(features[0].id ?? features[0].properties.tempid);
			return;
		}

		e.originalEvent.stopPropagation();

		var newSensor = {
			"geometry": {
				"coordinates": [e.lngLat.lng, e.lngLat.lat],
				"type": "Point"
			},
			"nsaid": 'temp_'+Math.random().toString(36).substr(2, 9),
			"name": "Sensor "+(this.tc.scenario.nsas.length+1),
			"type": "Feature",
			"shadow": {"hours":0,"minutes":0},
			"outdated" : true,
			"decibel": 0
		}

		this.tc.scenario.nsas.push(newSensor);
		this.resetLayer();

		//this.tc.scenario.modified = 1;
		//this.tc.setScenario(this.tc.scenario);
		//this.tc.record().add(this.tc.scenario);

		this.tc.map.fire("addSensor", {scenario:this.tc.scenario, sensor:newSensor});

		if(this.tc.scenario.scenario_id) {
			this.save(
				atlasApi.createSensor(
					this.tc.scenario.projectid,
					this.tc.scenario.scenario_id,
					e.lngLat.lat,
					e.lngLat.lng,
					newSensor.name
				).then((res) => {
					if(res?.properties?.nsa_id) {
						const tempId = newSensor.nsaid;
						const idx = this.tc.scenario.nsas.findIndex(s => s.nsaid === tempId);
						if(idx > -1) {
							this.tc.scenario.nsas[idx].nsaid = res.properties.nsa_id;
							this.tc.setScenario(this.tc.scenario);
							this.resetLayer();
						}
					}
					return res;
				})
			);
		}

	}
	removeSensor = (e, sId) =>{

		e?.originalEvent?.stopPropagation();
		var	sensorId;

		if(sId){
			sensorId = sId;
		}
		else {
			var features = this.tc.map.queryRenderedFeatures(e.point, {layers:[LayerSensor.layerId]});
			if(features.length)
				sensorId = features[0].id ?? features[0].properties.tempid;
		}
		if(!sensorId)
			return;

		this.updateSensor(sensorId, null);
		this.resetLayer();

		this.tc.map.fire("removeSensor", {scenario:this.tc.scenario, sensor:sensorId});
		this.display();
	}

	updateSensor = (nsaid, coordinates) => {

		if(!this.tc.scenario || !this.tc.scenario.scenario_id)
			return;
		
		const s = structuredClone(this.tc.scenario);
		var i = s.nsas.findIndex((elem)=>elem.nsaid == nsaid);
		if(i>-1){
			if(coordinates){
				s.nsas[i].geometry.coordinates = coordinates;
				//this.tc.record().add(this.tc.scenario);

				if(!isNaN(nsaid)) {
					this.save(
						atlasApi.updateSensor(
							this.tc.scenario.projectid,
							this.tc.scenario.scenario_id,
							nsaid,
							coordinates[1],
							coordinates[0]
						)
					);
				}
			}
			else{
				delete s.nsas[i].geometry;

				if(!isNaN(nsaid)) {
					this.save(
						atlasApi.deleteSensor(
							s.projectid,
							s.scenario_id,
							nsaid
						)
					);
				}

				if(typeof s.nsas[i].nsaid != 'number')
					s.nsas.splice(i, 1);
			}
			//this.tc.scenario.modified = 1;
			//this.tc.scenario = s;
			this.tc.setScenario(s);
		}
	}
	updateSensorName(name, nsaid, refresh){

		if(!this.tc.scenario || !this.tc.scenario.scenario_id)
			return;
		var i = this.tc.scenario.nsas.findIndex((elem)=>elem.nsaid == nsaid);
		if(i>-1){
			this.tc.scenario.nsas[i].name = name ? name : 'Sensor '+nsaid;

			if(!isNaN(nsaid) && atlasApi.updateSensorName)
				this.save(atlasApi.updateSensorName({name:name}, this.tc.scenario.projectid, this.tc.scenario.scenario_id, nsaid));

			this.tc.scenario.modified = 1;
		}

		if(refresh)
			this.resetLayer();
	}
	handleCalculate = (e) => {
		return this.calculation(true);
	}
	handleCalcRequestDone = (snackbar=false)=>{		
		if(this.silent)
			return;
		
		if(snackbar)
			this.tc.draw.context.QN.current.show("Noise and shadow calculation in progress. This process may take a few minutes.");

		this.stream.connect();
		if(snackbar)
			this.setJobCookie();
		this.display();
		
	}
	showCalcButton(){
		const statesShowingButton = ['error', 'not_found'];
		
		const newOrError = statesShowingButton.includes(this.noiseStatus.state) && statesShowingButton.includes(this.shadowStatus.state);
		
		
		return ((newOrError || this.tc.scenario.outdatedSensors || this.requestStatus.recalculate) && !!this.tc.scenario.nsas.length && !this.isOngoing());
	}
	hasNoData(){
		const states = ['not_found'];
		
		return states.includes(this.noiseStatus.state) && states.includes(this.shadowStatus.state) && !!this.tc.scenario.nsas.length;
		
		
	}
	isOngoing(){
		const states = [false, 'completed'];
		
		return (!states.includes(this.noiseStatus.state) || !states.includes(this.shadowStatus.state)) && !!this.tc.scenario.nsas.length;
		
		
	}
	calculation = (start)=>{
		const requests = [
			atlasApi.startNoiseLayer(this.tc.scenario.projectid, this.tc.scenario.scenario_id),
			atlasApi.startShadowLayer(this.tc.scenario.projectid, this.tc.scenario.scenario_id)
		];

		return Promise.all(requests).then((res)=>{
			
			if(!res[0] || !res[1])
				return ;
			
			this.tc.checkOutdated(res[0], false);
			this.tc.checkOutdated(res[1], false);
			
			this.noiseStatus = {"method":"","state":"waiting"};
			this.shadowStatus = {"method":"","state":"waiting"};

			this.display();
			return res[0];
		});
	}

	handleDoneCalc = () => {
		
		atlasApi.getSensors(this.tc.scenario.projectid, this.tc.scenario.scenario_id).then((res)=>{
			
			if(!Array.isArray(res))
				return false;
			
			var s = {...this.tc.scenario};
			
			s.outdatedSensors = !!res.reduce(function(filtered, option) {
				if (option.outdated) {
				   filtered.push(option.nsaid);
				}
				return filtered;
			}, []).length;
			
			s.nsas = res;
			
			this.tc.setScenario(s);
			
			if(this.tc.updatePanelLayer)
				this.tc.updatePanelLayer();
			this.display();
		});
	}
	
	unselectAll(){
		if(this.currentSensor)
			this.updateMapFeatPop("nsaid", this.currentSensor.nsaid, {selected: false});
	}
	select(id){
		this.updateMapFeatPop("nsaid", id, {selected: true});
	}
	handleSensorClick = (nsaid)=>{
		this.unselectAll();
		this.currentSensor = this.tc.scenario.nsas.find((s)=>{return s.nsaid == nsaid});
		this.select(nsaid);
		this.display();
	}
	tName(row, index){
		return row.name != '' ? row.name : 'Sensor '+ (index+1);
	}
	highlightOnMap = (id) => {
		this.lastHoverId = id;
		this.updateMapFeatPop("nsaid", id, {"hover": true});
	}
	deHighlightOnMap = (id) => {
		const resolvedId = id ?? this.lastHoverId;
		this.updateMapFeatPop("nsaid", resolvedId, {"hover": false});
	}
	highlightOnList = (id) => {
		this.highlightedOnList.push(this.idString(id));
		this.highlightedOnList = [...new Set(this.highlightedOnList)];
		this.display();
	}
	deHighlightOnList = (id) => {
		const index = this.highlightedOnList.indexOf(this.idString(id));
		if (index > -1) {
			this.highlightedOnList.splice(index, 1);
		}
		this.display();
	}
	handleRowClick = (row)=>{
		this.unselectAll();
		this.currentSensor = this.tc.scenario.nsas.find((s)=>{return s.nsaid == row.nsaid});
		this.select(row.nsaid);
		this.display();
	}
	handleHideAllItems = () => {
		Tool.prototype.handleHideAllItems.call(this);
		this.display();
	}
	closeContextMenu() {
		if(!this.tc)
			return;
		var a = false;
		if(a = this.tc.map.getContainer().querySelector(".toolContextMenu")){
			a.remove();
		}
	}
	handleRightClick = (e)=>{
		e.originalEvent.preventDefault();
		const el = e.originalEvent.target.closest(".sensor-marker");

		var features = this.tc.map.queryRenderedFeatures(e.point, {layers:[LayerSensor.layerId]});
		if(!features.length)
			return;

		var nsaid = features[0].id ?? features[0].properties.tempid;

		var wrp = document.createElement("div");
		wrp.className = "toolContextMenu";
		wrp.style.left = e.point.x+'px';
		wrp.style.top = e.point.y+'px';

		this.closeContextMenu();

		this.tc.map.getContainer().appendChild(wrp);

		ReactDOM.createRoot(wrp).render(this.contextMenu(e, nsaid));
	}
	handleHideAllSensors = () => {
		this.handleHideAllItems();
	}
	handleRemoveSensor = (e, sensorId) => {
		this.removeSensor(e, sensorId);
		this.display();
		return true;
	}
	handleSelect = (e, row) => {
		const id = "nsaid";
		if(!this.selected)
			this.selected = [];
		const idx = this.selected.findIndex((a)=>{return a[id] == row[id]});
		if(idx !== -1){
			this.selected.splice(idx, 1);
		}
		else{
			this.selected.push(row);
		}
		this.display();
	}
	handleSelectAll = () => {
		if (!this.selected) this.selected = [];
		const items = (this.tc.scenario.nsas ?? []).filter(t => !!t.geometry);
		const allSelected = items.length > 0 && items.every(d => this.selected.some(s => s.nsaid === d.nsaid));
		if (allSelected) { this.selected = []; } else { this.selected = items.slice(); }
		this.display();
	}
	removeItem = (id) => {
		const s = this.tc.scenario;
		const i = s.nsas.findIndex(e => e.nsaid == id);
		if (i > -1) {
			delete s.nsas[i].geometry;
			if (typeof s.nsas[i].nsaid !== 'number')
				s.nsas.splice(i, 1);
			this.tc.setScenario(s);
		}
		this.tc.map.fire("removeSensor", { scenario: this.tc.scenario, sensor: id });
	}

	bulkDeleteApi = (ids) => atlasApi.bulkDeleteSensors(this.tc.scenario.projectid, this.tc.scenario.scenario_id, ids);

	afterBulkDelete = () => {
		this.resetLayer();
	}
	handleUpdateName(newName, id){
		this.updateSensorName(newName, id, true);
		this.display();
	}
	handleEditSensor(e, nsaid){
		document.getElementById('edit-static-sensor-'+nsaid).dispatchEvent(new MouseEvent("dblclick", {'view': window,'bubbles': true,'cancelable': true}))
	}
	handleExitDetail = (e)=>{
		this.unselectAll();
		this.currentSensor = null;
		this.display();
	}
	isSelectedOnList = (row)=>{
		return this.highlightedOnList.includes(this.idString(row.nsaid));
	}
	contextMenu = (map_event, nsaid)=>{
		return (
			<>
				<button className="btn" onClick={(e)=>{this.handleEditSensor(map_event, nsaid); this.closeContextMenu();}}><PencilSimple size={20} /> Edit name</button>
				<button className="btn" onClick={(e)=>{this.removeSensor(null, nsaid); this.closeContextMenu();}}><Trash size={20} /> Remove Sensor</button>
			</>
		);
	}
	formatNoise(val){
		return (isNaN(val) || val == "" ? 0 : parseFloat(val)) + ' dB';
	}
	formatShadow(shadow){
		if(!shadow) return '0h 0m / yr';
		return shadow.hours+'h '+shadow.minutes+'m / yr';
	}

	display = () => {
		if(this.tc.serviceBar.current)
			ToolSensor.tabIndex = this.tc.serviceBar.current.inject(this.currentSensor ? this.renderDetail() : this.render(), ToolSensor.tabIndex);
	}
	getStreamerState(json){
		const states = ['queued', 'processing', 'completed', 'error', 'not_found', 'outdated'];
		const noiseIdx = states.indexOf(json?.noise?.state);
		const shadowIdx = states.indexOf(json?.shadow?.state);
		const validNoise = noiseIdx !== -1;
		const validShadow = shadowIdx !== -1;
		
		this.tc.checkOutdated(json?.noise);
		
		if(
			(Array.isArray(json?.noise?.outdatedSensors) && json?.noise.outdatedSensors.length)
			||
			(Array.isArray(json?.shadow?.outdatedSensors) && json?.shadow.outdatedSensors.length)
		){
			return states[5];
		}
		
		this.noiseStatus = json.noise;
		this.shadowStatus = json.shadow;
		
		if (!validNoise && !validShadow) return null;
		if (!validNoise) return json.shadow.state;
		if (!validShadow) return json.noise.state;
		return states[Math.min(noiseIdx, shadowIdx)];
	}
	renderDetail(){

		if(!this.currentSensor)
			return;

		return (

			<div className={"project-sensors "}>
				<div className="title">
					{this.currentSensor.name}
					<span onClick={(e)=>{this.handleExitDetail()}} 	className="btn btn-close alt float-end"><X size={16} /></span>
				</div>
				<div className="scroll">

					<div className="separator">
						<span>About this sensor</span>
					</div>
					<div className="sensor-detail">

						<Row className="basic-info mb-2">
							<Col xs="12">
								<MapPinSimple size={16} />
								<span>Name: </span>
								<EditNow id={'sensor-'+this.currentSensor.nsaid} value={this.currentSensor.name} editable={true} onUpdate={(val)=>{this.handleUpdateName(val, this.currentSensor.nsaid)}} />
							</Col>
						</Row>
						<Row className="basic-info mb-2">
							<Col xs="12">
								<Moon size={16} />
								<span>Shadow: </span>
								{this.formatShadow(this.currentSensor.shadow)}
							</Col>
						</Row>
						<Row className="basic-info mb-2">
							<Col xs="12">
								<Waveform size={16} />
								<span>Noise: </span>
								{this.formatNoise(this.currentSensor.decibel)}
							</Col>
						</Row>
					</div>
				</div>

			</div>

		);

	}
	render(){

		const sensors = this.tc.scenario.nsas ? this.tc.scenario.nsas.filter((t) => t.geometry ? true : false) : (this.tc.scenario.nsas = []);
		const no_data = this.hasNoData();
		const ongoing = this.isOngoing();
		const outdated = (this.tc.scenario.outdatedSensors ?? false);
		const outdatedCount = this.tc.scenario.nsas.filter(a=>a.outdated).length;
		
		if(outdated && !ongoing)
			this.requestStatus.css = "text-warning";
		
		const anim = ongoing ? this.calcAnim : [];
		
		return (

			<div className={"project-sensors "}>
				<div className="title">
					Sensors
				</div>
				<div className="scroll">
					<div className="content p-0">

						<DataTable
							data={sensors} 
							conditionalRowStyles={anim}
							columns={
								[
									{
										name:<Eye onClick={this.handleHideAllItems} className={""+(this.areAllHidden() ? 'opacity-25' : '')} size={16} />,
										id:'userid',
										selector: row => row.userid,
										format: (row) => (<Eye onClick={(e)=>{this.handleToggleItem(e, row.nsaid, undefined, false)}} id={"bndr_"+row.nsaid} data-id={row.nsaid} className={""+(this.hiddenItems.includes(row.nsaid) || this.areAllHidden() ? 'opacity-25' : '')} size={16} />),
										width:"28px",
										style: {
											padding: '0',
										}
									},
									{
										name:(
											<Form.Check
												type="checkbox"
												checked={!!(this.tc.scenario.nsas?.filter(t=>!!t.geometry).length) && this.tc.scenario.nsas.filter(t=>!!t.geometry).every(d => this.selected && this.selected.some(s => s.nsaid === d.nsaid))}
												ref={el => { if (el) el.indeterminate = !!(this.selected?.length) && this.selected.length < (this.tc.scenario.nsas?.filter(t=>!!t.geometry).length ?? 0); }}
												onChange={this.handleSelectAll}
											/>
										),
										selector: this.tName,
										format: (row,index) => ( <label className="checkbox-pad"><Form.Check type="checkbox" id={"check-"+row.nsaid} checked={this.selected && this.selected.some((a)=>a.nsaid == row.nsaid)} onClick={(e)=>{this.handleSelect(e, row);}} /></label>),
										width:"25px",
										style: {
											padding: '0px !important',
										}
									},
									{
										name:'NAME',
										selector: this.tName,
										format: (row,index) => (<EditNow id={'sensor-'+row.nsaid} value={this.tName(row,index)} onClick={(e)=>{this.handleRowClick(row)}} editable={true} onUpdate={(val)=>{this.handleUpdateName(val, row.nsaid)}} />),
										sortable:true,
										width:"100%",
									},
									{
										name:'SHADOW',
										selector: (row) => {return row.shadow ? row.shadow.hours+(row.shadow.hours/100) : 0},
										format: (row,index) => (this.formatShadow(row.shadow)),
										sortable:true,
										width:"85px",
										style: {
											textAlign:'right',
										}
									},
									{
										name:'NOISE',
										selector: (row) => {return row.decibel},
										format: (row,index) => (this.formatNoise(row.decibel)),
										sortable:true,
										width:"70px",
										style: {
											textAlign:'right',
										}
									},
									{
										name:'',
										selector:(row)=>{

												
											return <> {row.outdated ? <Circle className="outdated" size={16} color="#FEC84B" weight="fill" /> : ''}</>
										},
										sortable:false,
										width:"16px",
										center: true,
										style: {
											padding: '0',
											textAlign:'right',
										}
									},
									{
										name:'',
										cell: row => (
											<div className="context-menu" data-tag="allowRowEvents">
													<Dropdown className="minimal">
														<Dropdown.Toggle className="p-0 px-1" variant="default">
															<DotsThreeVertical size={16} />
														</Dropdown.Toggle>
														<Dropdown.Menu>
															<Dropdown.Item href="#" onClick={(e)=>{ this.handleEditSensor(e, row.nsaid);   }}><PencilSimple size={16} /> Edit name</Dropdown.Item>
															<Dropdown.Item href="#" onClick={(e)=>{ this.handleRemoveSensor(e, row.nsaid); }} className="text-danger" ><Trash size={16} /> Remove sensor</Dropdown.Item>
														</Dropdown.Menu>
													</Dropdown>
											</div>
										),
										width:"20px"

									}
								]
							}
							customStyles={{
								headCells:{
									style: {
										padding:'.5rem .3rem',
										minWidth:'0px !important',
										boxSizing:'content-box',
										fontWeight:'bold'
									}
								},
								cells:{
									style: {
										padding:'.5rem .3rem',
										minWidth:'0px !important',
										boxSizing:'content-box',
										fontSize: 'var(--bs-body-font-size);',
										color:'var(--bs-body-color)',
										'&:last-child':{paddingRight:'1rem'}
									}
								},
								rows:{
									style: {
										minHeight:"0",
									},
									selectedHighlightStyle:{
										backgroundColor:'red'
									}
								}
							}}
							onRowMouseEnter={row=>this.highlightOnMap(row.nsaid)}
							onRowMouseLeave={row=>this.deHighlightOnMap(row.nsaid)}
							onRowClicked={this.handleRowClick}
							selectableRowSelected={r=>this.isSelectedOnList(r)}
							highlightOnHover
							selectableRowsHighlight
							pointerOnHover
							sortIcon={<i className="ri-expand-up-down-line" />}
							noDataComponent={

								<Row className="p-0 py-3 m-0">

									<Col xs="1 pe-0">
										<Info className="text-danger" weight="bold" size={15} />
									</Col>
									<Col xs="11 ps-0">
										<b>Please note:</b> There are currently no sensors placed in this scenario. You can still view the general noise and shadow overlay. 
										<br />
										<br />
										Place sensors for location-specific data..
									</Col>

								</Row>
							}
						/>

						{this.selected && !!this.selected.length &&
							<Row className="p-3 batch-action">
								<Col xs="6">
									{this.selected.length} Items selected
								</Col>
								<Col xs="6 text-end">
									<Button variant="primary" onClick={this.handleBulkDelete}>Delete</Button>
								</Col>
							</Row>
						}
						{(this.tc.scenario.nsas.length && (!this.selected || !this.selected.length)) &&
							<Row className="p-3 batch-action">
								<Col xs="2">
									Total
								</Col>
								<Col xs="2 text-bold text-nowrap p-0">
									{this.tc.scenario.nsas.length } Sensors - 
								</Col>
								<Col xs="8" className={"total-status " + this.requestStatus.css}>
									{!outdated && !ongoing && "All data up to date"}
									{outdated && !ongoing && `${outdatedCount} need recalculation` }
									{ongoing && `updating ${outdatedCount} sensor${outdatedCount>1?'s':''}...` }
									
								</Col>
							</Row>
						}
					</div>

				</div>
				<div className="content">
				
					{!!no_data &&

						<Alert variant="" className="with-icon m-0 mt-2 mb-4 p-0">
							<div className="icon">
								<Info className="text-primary" weight="bold" size={16} />
							</div>
							<div className="text">
								<b>No values calculated yet.</b> Run a first calculation to generate noise and shadow data.
							</div>

						</Alert>

					}
					{(outdated  || ongoing) &&

						<Alert variant="warning" className="with-icon m-0 mt-2 mb-4">
							<div className="icon">
								<Warning className="text-danger" weight="bold" size={16} />
							</div>
							<div className="text">
								<b>Important:</b> Turbine positions, models, or hub heights have changed. Recalculate changes to update AEP.
							</div>

						</Alert>

					}

					{this.showCalcButton() &&
						<DoNowButton
							iconIdle={<Calculator  size={16} weight="bold" />}
							btnClassName="btn-land-actions land-book mb-3"
							onClick={()=>{return this.handleCalculate(); }}
							onFinish={()=>{this.handleCalcRequestDone(true)}}
							text={(no_data ? this.stateMsgs.new : this.stateMsgs.again)}
							textLoading={this.stateMsgs.pending}
						/>
					}
					
					<ShowStatus status={this.requestStatus} />

					

				</div>
			</div>

		);

	}
}

export default ToolSensor;
